import Vue from 'vue';
import Router from 'vue-router';

const Page404 = () => import('@/components/views/Page404');
const Page401 = () => import('@/components/views/Page401');
const PlnDocument = () => import('@/components/views/PlnDocument');

Vue.use(Router);
export default new Router({
  mode: 'history',
  base: '/',
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes(){
  return [
    {
      path: '/',
      name: 'PlnDocument',
      component: PlnDocument
    },
    {
      path: '/401',
      name: 'Page 401',
      component: Page401
    },
    {
      path: '/*',
      name: 'Page 404',
      component: Page404
    }
  ]
}
